import React from 'react';

interface DownloadIconProps {
  size?: number;
  className?: string;
}

const DownloadIcon: React.FC<DownloadIconProps> = ({ size = 20, className = '' }) => {
  const reactId = React.useId();
  const maskId = `download-icon-mask-${reactId.replace(/\W/g, '_')}`;

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 20 20" 
      fill="none"
      className={className}
    >
      <mask id={maskId} style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9"/>
      </mask>
      <g mask={`url(#${maskId})`}>
        <path d="M9.99992 12.9798C9.88881 12.9798 9.78464 12.9625 9.68742 12.9277C9.5902 12.893 9.49992 12.834 9.41659 12.7507L6.41659 9.75065C6.24992 9.58398 6.17006 9.38954 6.177 9.16732C6.18395 8.9451 6.26381 8.75065 6.41659 8.58398C6.58325 8.41732 6.78117 8.33051 7.01034 8.32357C7.2395 8.31662 7.43742 8.39648 7.60409 8.56315L9.16659 10.1257V4.16732C9.16659 3.93121 9.24645 3.73329 9.40617 3.57357C9.56589 3.41385 9.76381 3.33398 9.99992 3.33398C10.236 3.33398 10.4339 3.41385 10.5937 3.57357C10.7534 3.73329 10.8333 3.93121 10.8333 4.16732V10.1257L12.3958 8.56315C12.5624 8.39648 12.7603 8.31662 12.9895 8.32357C13.2187 8.33051 13.4166 8.41732 13.5833 8.58398C13.736 8.75065 13.8159 8.9451 13.8228 9.16732C13.8298 9.38954 13.7499 9.58398 13.5833 9.75065L10.5833 12.7507C10.4999 12.834 10.4096 12.893 10.3124 12.9277C10.2152 12.9625 10.111 12.9798 9.99992 12.9798ZM4.99992 16.6673C4.54159 16.6673 4.14922 16.5041 3.82284 16.1777C3.49645 15.8513 3.33325 15.459 3.33325 15.0007V13.334C3.33325 13.0979 3.41311 12.9 3.57284 12.7402C3.73256 12.5805 3.93047 12.5007 4.16659 12.5007C4.4027 12.5007 4.60061 12.5805 4.76034 12.7402C4.92006 12.9 4.99992 13.0979 4.99992 13.334V15.0007H14.9999V13.334C14.9999 13.0979 15.0798 12.9 15.2395 12.7402C15.3992 12.5805 15.5971 12.5007 15.8333 12.5007C16.0694 12.5007 16.2673 12.5805 16.427 12.7402C16.5867 12.9 16.6666 13.0979 16.6666 13.334V15.0007C16.6666 15.459 16.5034 15.8513 16.177 16.1777C15.8506 16.5041 15.4583 16.6673 14.9999 16.6673H4.99992Z" fill="#3A424D"/>
      </g>
    </svg>
  );
};

export default DownloadIcon;